import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import moment from 'moment';

const Config = require('../../config');

class ModalUserTraceability extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:  false, 
			traceability:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'traceabilities/by_offer?offer_id='+id,{
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					traceability: response.res,
					show: true,
				});
			}
		})
	}

	handleClose(){
		this.setState({
			show: false,
			traceability:[]
		});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Trazabilidad</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<Table resposive hover>
								<thead>
									<tr>
										<th>No. Unidad</th>
										<th>Descripción</th>
										<th>Fecha</th>
										<th>Usuario</th>
										<th>IP</th>
									</tr>
								</thead>
								<tbody>
									{this.state.traceability.map((t, i)=>(
										<tr key={i}>
											<td>{t.unit_number}</td>
											<td>{t.description}</td>
											<td>{t.timestamp !== null ?
													moment(t.timestamp).format('DD/MM/YYYY HH:mm')
												: ""}</td>
											<td>{t.user}</td>
											<td>{t.ip}</td>
										</tr>
									))}
								</tbody>
							</Table>
		        		</div>
					</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}  />
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations') (ModalUserTraceability);
